import ThemeDto from './ThemeDto'

export default class {
	constructor(obj) {
		this.id = obj.id
		this.comment = obj.comment
		this.title = obj.title
		this.image = obj.image
		this.color = obj.color
		this.themes = obj.themes.map(t => Object.assign({}, new ThemeDto(t)))
	}
}



// WEBPACK FOOTER //
// ./src/administration/dto/MasterThemeDto.js